import { Component, AfterViewInit, Inject, Input, Output, EventEmitter, ViewChild } from "@angular/core";

import { HttpErrorResponse } from "@angular/common/http";
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MatStep, MatStepper } from '@angular/material/stepper';

import { Observable, Subject } from 'rxjs';
import { catchError } from "rxjs/operators";

import { applicationConstants } from '../../../../app.constants';
import { CategoryBuilder } from '../../../../shared/suggestable-input/components/suggestable-input.component';
import { Events, EventBusService } from '../../../../technical-modules/events/services/event-bus.service';
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class";

import { AntenneService } from "../../../structure/antenne/services/antenne.service";
import { AntenneTLR } from "../../../structure/antenne/entities/antenne-tlr.entity";
import { EntrepriseTLR } from "../../../entreprises/entities/entreprise-tlr.entity";
import { EntrepriseService } from "../../../entreprises/services/entreprise.service";
import { IntervenantService } from "../../../humain/intervenant/services/intervenant.service";
import { IntervenantEntity } from "../../../humain/intervenant/entities/intervenant.entity";
import { IntervenantTLR } from "../../../humain/intervenant/entities/intervenant-tlr.entity";
import { IndicatifEntity } from "../../../indicatif-tel/indicatif.entity";
import { IndicatifService } from "../../../indicatif-tel/indicatif.service";
import { TypeMaintenanceService } from "../../../planification-maintenance/type-maintenance/services/type-maintenance.service";

import { CommunicationMutuelleInfoEntity } from "../../entities/communication-mutuelle-info.entity";
import { EtatPdp, PlanPreventionEntity } from "../../entities/plan-prevention.entity";
import { EntrepriseExterieureEntity } from "../../entities/entreprise-exterieure.entity";
import { NatureInterventionEntity } from "../../entities/nature-intervention.entity";
import { PlanPreventionService } from "../../services/plan-prevention.service";
import { TravauxPdpEntity } from "../../entities/travaux-pdp.entity";
import { StepFinalModel } from "../../entities/step-final-model.entity";
import { TraductionPdp } from '../../entities/traduction-pdp.entity';
import { TraductionDto } from '../../entities/traduction-pdp.dto';

enum Coactivite {
	POSSIBLE = "POSSIBLE",
	NON_POSSIBLE = "NON_POSSIBLE"
}
type RefTravaux = {
	[id: number]: number;
}
type RefEntreprises = {
	[id: number]: string;
}
type MapEntrepriseExterieure = {
	[id: number]: EntrepriseExterieureEntity;
}
@Component({
	selector: 'plan-prevention-details',
	templateUrl: 'plan-prevention-details.html',
	styleUrls: ['plan-prevention-details.css'],
})

export class PlanPreventionDetailsComponent implements AfterViewInit {

	etatPdp: typeof EtatPdp = EtatPdp;

	/*Général */
	planPreventionModel!: PlanPreventionEntity;
	nextDisabled!: boolean;

	/* Travaux */
	idTravaux: number = 0;
	travaux: TravauxPdpEntity[] = [];
	typeMaintenanceSuggestion!: string[];
	entreprises!: EntrepriseTLR[];
	availableEntreprises!: EntrepriseTLR[];
	listeCoactivite: string[] = ['Possible', 'Non Possible'];
	coactivite: string = 'Possible';
	designation!: string;
	entreprisesConcernees!: EntrepriseTLR[];
	sousTraitantsConcernees!: EntrepriseTLR[];
	indicatifsTel: IndicatifEntity[] = [];

	/* Entreprise utilisatrice */
	referentParc!: IntervenantEntity;
	raisonSociale: string = applicationConstants.raisonSocialeEngieGreen;
	adresseEU: string = applicationConstants.adresseEngieGreen;
	telFax: string = applicationConstants.telFaxEngieGreen;
	nomPrenomReferent!: string;
	emailReferent!: string;
	fonctionReferent!: string;
	telephoneReferent!: string;
	telephoneAstreinte: string[] = [];
	idEntrepriseReferent!: number;
	emailGenerique!: string;

	getNumeroAstreinteLabel = (numeroAstreinte: string) => numeroAstreinte;
	initAstreinteCommand = new Subject<void>();
	numeroAstreintesCommand = new Subject<string[]>();
	existingAstreintesCommand = new Subject<string[]>();
	antennes: Map<number, AntenneTLR> = new Map<number, AntenneTLR>();

	/* Entreprises Exterieures (EE) et Sous-Traitantes (ST) */
	entreprisesExterieures: EntrepriseExterieureEntity[] = [];
	indicatifTelRepresentant: IndicatifEntity = new IndicatifEntity(); telephoneRepresentant!: string;
	emailRepresentant!: string;
	effectifMoyen!: string;

	communicationMutuelleInfo!: CommunicationMutuelleInfoEntity;

	riskActivities: TraductionPdp[] = [];
	risks: TraductionPdp[] = [];
	riskMesures: TraductionPdp[] = [];
	impactActivities: TraductionPdp[] = [];
	impacts: TraductionPdp[] = [];
	impactMesures: TraductionPdp[] = [];
	entreprisesExterieuresData: MapEntrepriseExterieure = {};
	mandatoryStepOne: boolean = false;
	mandatoryStepTwo: boolean = false;
	mandatoryStepFive: boolean = false;
	mandatoryStepSix: boolean = false;
	mandatoryStepSeven: boolean = false;
	anyInputAutreRiskEmpty: boolean = false;
	aucunRiskChoisi: boolean = false;
	activeStep: number = 1;

	pdpIdForDuplication: number = -1;

	highlightedTrads: number[] = [];
	highlightedSections: number[] = [];

	energieSubject = new Subject<string | null>();

	designationInitialValueSubject: Subject<string | null>[] = [];

	suggestionsGetterForResponsable = (entrepriseId: number) => {
		return (criteria: string) => this.intervenantService.getSuggestionsResponsables(entrepriseId, criteria, 15);
	}

	// Liaison de l'observable servant a commander l'affichage du composant
	private editCommandsSubject = new SubjectRelay<PlanPreventionEntity>();
	@Input() set editCommands(obs: Observable<PlanPreventionEntity> | undefined) {
		this.editCommandsSubject.registerSource(obs);
	}

	generationCommands = new Subject<PlanPreventionEntity>();
	infosGeneraleCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	communicationMutuelleCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	analyseImpactsCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	analyseRisquesCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	finalisationPdpCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	finalisationTypePdpCommands: Subject<number> = new Subject<number>();
	finalisationIdPdpCommands: Subject<number> = new Subject<number>();
	finalisationVersionPdpCommands: Subject<number> = new Subject<number>();
	pdpToCopyRisks: Subject<number> = new Subject<number>();
	pdpToCopyImpacts: Subject<number> = new Subject<number>();
	pdpToCopyInFinalisation: Subject<number> = new Subject<number>();

	finalisationEntreprisesPouvantSignerCommands: Subject<EntrepriseTLR[]> = new Subject<EntrepriseTLR[]>();
	finalisationEntrepriseUtilisatriceCommands: Subject<EntrepriseTLR> = new Subject<EntrepriseTLR>();

	@Output() viewChange = new EventEmitter<string>();

	@ViewChild('step1') step1!: MatStep;
	@ViewChild('step2') step2!: MatStep;
	@ViewChild('step3') step3!: MatStep;
	@ViewChild('step4') step4!: MatStep;
	@ViewChild('step5') step5!: MatStep;
	@ViewChild('step6') step6!: MatStep;
	@ViewChild('step7') step7!: MatStep;

	steps: MatStep[] = [];

	ngAfterViewInit() {
		this.steps = [this.step1, this.step2, this.step3, this.step4, this.step5, this.step6, this.step7];
	}

	constructor(
		@Inject(AntenneService) private antenneService: AntenneService,
		@Inject(EntrepriseService) private entrepriseService: EntrepriseService,
		@Inject(EventBusService) private eventBusService: EventBusService,
		@Inject(IndicatifService) private indicatifService: IndicatifService,
		@Inject(IntervenantService) private intervenantService: IntervenantService,
		@Inject(PlanPreventionService) private planPreventionService: PlanPreventionService,
		@Inject(TypeMaintenanceService) private typeMaintenanceService: TypeMaintenanceService,
	) {
		this.editCommandsSubject.subscribe(
			// lors de la reception d'une demande d'affichage
			(pdp: PlanPreventionEntity) => {
				// remises à zero
				for (let i = 1; i <= 7; i++) {
					this.steps[i - 1].completed = false;
				}
				this.idTravaux = 0;
				this.activeStep = 1;
				this.initAstreinteCommand.next();
				this.pdpIdForDuplication = -1;

				if (pdp.mode === 'duplicate') {
					this.pdpIdForDuplication = pdp.id.valueOf();
					this.pdpToCopyRisks.next(this.pdpIdForDuplication);
					this.pdpToCopyImpacts.next(this.pdpIdForDuplication);
					this.pdpToCopyInFinalisation.next(this.pdpIdForDuplication);
				} else if (pdp.mode === 'create') {
					this.travaux = [];
					this.designationInitialValueSubject = [];
					this.telephoneAstreinte = [];
					this.entreprisesExterieures = [];
					this.pdpToCopyInFinalisation.next(-1);
				} else if (pdp.mode === 'update') {
					for (let i = 1; i <= 7; i++) {
						this.steps[i - 1].completed = pdp.lastCompletedStep >= i;
					}
					this.pdpToCopyInFinalisation.next(-1);
				}
				this.planPreventionModel = pdp;
				this.analyseImpactsCommands.next(pdp);
				this.analyseRisquesCommands.next(pdp);
				this.infosGeneraleCommands.next(pdp);
				this.communicationMutuelleCommands.next(pdp);
				this.finalisationPdpCommands.next(pdp);
				this.loadReferenceData();
			}
		);
	}

	loadReferenceData() {
		this.antenneService.getAntenneTLRMapById().subscribe(
			(antennes: Map<number, AntenneTLR>) => {
				this.antennes = antennes;
				this.indicatifService.getAllIndicatif().subscribe(
					(data: IndicatifEntity[]) => {
						this.indicatifsTel = data;
						// poursuite : chargement d'autres données
						this.finalisationEntreprisesPouvantSignerCommands.next([]);
						if (this.planPreventionModel.mode !== 'create') {
							this.loadDataForExistingPdp();
						}
						// reset en mode duplicate
						if (this.planPreventionModel.mode === 'duplicate') {
							this.planPreventionModel.etat = EtatPdp.BROUILLON;
							this.planPreventionModel.id = -1;
						}
					}
				);
			}
		);
	}

	loadDataForExistingPdp() {
		// remplissage des astreintes par défaut
		const antenneAstreintes = this.antennes.get(this.planPreventionModel.antenneId)?.telephoneAstreintes;
		this.numeroAstreintesCommand.next(antenneAstreintes);
		// chargement donnees travaux
		this.loadTravauxForExistingPdp();
	}

	loadTravauxForExistingPdp() {
		let pdpRefId = this.planPreventionModel.mode === 'duplicate' ? this.pdpIdForDuplication : this.planPreventionModel.id;
		this.planPreventionService.getTravaux(pdpRefId).subscribe(
			(data: PlanPreventionEntity) => {
				// Recuperer les donnees de l'entreprise utilisatrice
				this.raisonSociale = data.raisonSociale ? data.raisonSociale : applicationConstants.raisonSocialeEngieGreen;
				this.adresseEU = data.adresseEU ? data.adresseEU : applicationConstants.adresseEngieGreen;
				this.telFax = data.telFax ? data.telFax : applicationConstants.telFaxEngieGreen;

				if (this.planPreventionModel.referentParcId) {
					// Charger les donnees du referent
					this.intervenantService.getIntervenantById(this.planPreventionModel.referentParcId).subscribe((chargesAcces: IntervenantEntity) => {
						this.referentParc = chargesAcces;
						this.nomPrenomReferent = data.nomPrenomReferent ? data.nomPrenomReferent : [this.referentParc.nom, this.referentParc.prenom].join(' ');
						this.fonctionReferent = data.fonctionReferent ? data.fonctionReferent : this.referentParc.cadreEmploi;
						this.telephoneReferent = data.telephoneReferent ? data.telephoneReferent : this.referentParc.telephone;
						this.emailReferent = data.emailReferent ? data.emailReferent : this.referentParc.email;
					});
				}

				let refTravaux: RefTravaux = {};
				let refEntreprises: RefEntreprises = {};
				this.travaux = [];
				this.designationInitialValueSubject = [];

				let travaux = data.travaux;
				for (let i = 0; i < travaux.length; i++) {
					let tr = new TravauxPdpEntity();
					this.idTravaux = i + 1;
					tr.id = this.idTravaux;
					refTravaux[travaux[i].id] = tr.id;
					tr.designation = travaux[i].designation;
					this.designationInitialValueSubject.push(new Subject<string | null>())
					setTimeout(
						() => this.designationInitialValueSubject[i].next(tr.designation),
						300
					);

					tr.selectedEntreprises = [];
					travaux[i].entreprisesConcernees.forEach($ => {
						refEntreprises[$.id] = $.nom;
						let entrepriseConcernee: EntrepriseTLR = new EntrepriseTLR();
						entrepriseConcernee.id = $.id;
						entrepriseConcernee.nom = $.nom;
						tr.selectedEntreprises.push({ entreprise: entrepriseConcernee });
					});
					tr.selectedSousTraitants = [];
					travaux[i].sousTraitantsConcernes.forEach($ => {
						refEntreprises[$.id] = $.nom;
						let soustraitantConcerne: EntrepriseTLR = new EntrepriseTLR();
						soustraitantConcerne.id = $.id;
						soustraitantConcerne.nom = $.nom;
						tr.selectedSousTraitants.push({ entreprise: soustraitantConcerne });
					});
					tr.coactivite = (travaux[i].coactivite === 'POSSIBLE') ? 'Possible' : 'Non Possible';
					tr.updatable = false;
					this.travaux.push(tr);
				}
				let entreprisesExterieures = data.entreprisesExterieures;
				this.entreprisesExterieuresData = {};
				this.entreprisesExterieures = [];
				for (let i = 0; i < entreprisesExterieures.length; i++) {
					let ee = new EntrepriseExterieureEntity();
					ee.idEntrepriseExt = entreprisesExterieures[i].idEntrepriseExt;
					ee.nomRepresentant = entreprisesExterieures[i].nomRepresentant;
					ee.nomEntreprise = refEntreprises[entreprisesExterieures[i].idEntrepriseExt];
					ee.raisonSociale = entreprisesExterieures[i].raisonSociale;
					ee.natureInterventions = [];
					entreprisesExterieures[i].natureInterventions.forEach($ => {
						let ni = new NatureInterventionEntity();
						ni.travauxPdpId = refTravaux[$.travauxPdpId];
						ni.intervention = $.intervention;
						ee.natureInterventions.push(ni);
					});
					let index = this.entreprisesExterieures.findIndex(value => entreprisesExterieures[i].idEntrepriseExt === value.idEntrepriseExt);
					if (index === -1) {
						let entTlr = new EntrepriseTLR();
						entTlr.id = ee.idEntrepriseExt;
						entTlr.nom = ee.nomEntreprise;
						entTlr.raisonSociale = ee.raisonSociale;
						this.entreprisesExterieures.push(ee);
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt] = new EntrepriseExterieureEntity();
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].idEntrepriseExt = ee.idEntrepriseExt;
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].nomEntreprise = ee.nomEntreprise;
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].raisonSociale = entreprisesExterieures[i].raisonSociale;
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].nomRepresentant = entreprisesExterieures[i].nomRepresentant;

						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].fonctionRepresentant = entreprisesExterieures[i].fonctionRepresentant;
						if (entreprisesExterieures[i].indicatifIdRepresentant) {
							for (let j = 0; i < this.indicatifsTel.length; j++) {
								if (this.indicatifsTel[j].id === entreprisesExterieures[i].indicatifIdRepresentant) {
									this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].indicatifRepresentant = this.indicatifsTel[j];
									break;
								}
							}
						}
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].telephoneRepresentant = entreprisesExterieures[i].telephoneRepresentant;
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].emailRepresentant = entreprisesExterieures[i].emailRepresentant;
						this.entreprisesExterieuresData[entreprisesExterieures[i].idEntrepriseExt].effectifMoyen = entreprisesExterieures[i].effectifMoyen;
					}
				}
				if (this.planPreventionModel.lastCompletedStep >= 1) {
					this.prevalidateStepOne();
				}
			}
		);

		this.emailGenerique = this.planPreventionModel.emailGenerique;

		this.telephoneAstreinte = this.planPreventionModel.astreinte ? this.planPreventionModel.astreinte : [];
		this.existingAstreintesCommand.next(this.telephoneAstreinte);
	}

	/**                                                                                      **
	 ******************************* TRAVAUX - ENTREPRISES *************************************
	 **                                                                                      **/
	getEntrepriseLabel = (entreprise: EntrepriseTLR) => entreprise.nom;

	getIndicatifLabel = (indicatif: IndicatifEntity) => indicatif.countryName + ' (' + indicatif.countryCode + ') ' + indicatif.dialCode;

	getIntervenantLabel = (intervenant: IntervenantTLR) => [intervenant.nom, intervenant.prenom].join(' ');
	suggestionCategoryBuilders: CategoryBuilder<number, IntervenantTLR>[] = [
		{
			titleGetter: (possibles: number) => {
				if (possibles === 0) {
					return "Aucun résultat";
				}
				if (possibles > 15) {
					return possibles + "résultats";
				}
				return null;
			},
			suggestionsFilter: (_suggestion: IntervenantTLR) => true,
		},
	];

	private initEntreprisesAndSousTraitantsLists(value: TravauxPdpEntity, entreprises: EntrepriseTLR[]) {
		value.entreprisesById = new Map<number, EntrepriseTLR>();
		for (let entreprise of entreprises) {
			value.entreprisesById.set(entreprise.id, entreprise);
		}
		value.availableEntreprises = [...entreprises];
		value.entreprisesSelected = new Map<number, boolean>();
		value.sousTraitantsSelected = new Map<number, boolean>();
		for (let entreprise of entreprises) {
			value.entreprisesSelected.set(entreprise.id, false);
			value.sousTraitantsSelected.set(entreprise.id, false);
		}
		value.selectedEntreprises = [];
		value.selectedSousTraitants = [];
	}

	getSuggestedTypeMaintenanceCode(libelle: any) {
		return libelle;
	}

	onEntrepriseSelected(entreprise: EntrepriseTLR, element: any) {
		if (entreprise) {
			let travauxPdpEntity = this.travaux[element.id - 1];
			travauxPdpEntity.entreprisesSelected.set(entreprise.id, true);
			this.updateAvailableEnteprises(travauxPdpEntity);
			travauxPdpEntity.selectedEntreprises.push({ entreprise: entreprise });
			this.addEntrepriseExterieureOuSousTraitante(entreprise, travauxPdpEntity);

			setTimeout(() => {
				// Remettre la selection a zero
				// Il faut attendre un leger delai pour cependant que le binding mette en premier lieu la variable selectedEnreprise a jour
				// Sinon le moteur risque de ne pas comprendre qu'il y a une remise a zero a effectuer
				travauxPdpEntity.selectedEntreprise = null;
			}, 100);
		}
	}

	onEntrepriseDeselected(index: number, element: any) {
		let travauxPdpEntity = this.travaux[element.id - 1];
		let entreprise = travauxPdpEntity.selectedEntreprises[index].entreprise;
		travauxPdpEntity.entreprisesSelected.set(entreprise.id, false);
		this.updateAvailableEnteprises(travauxPdpEntity);
		this.removeEntrepriseOrDesignationFromEntrepriseExtList(entreprise, element);
		travauxPdpEntity.selectedEntreprises.splice(index, 1);
	}

	onSousTraitantSelected(entreprise: EntrepriseTLR, element: any) {
		if (entreprise) {
			let travauxPdpEntity = this.travaux[element.id - 1];
			travauxPdpEntity.sousTraitantsSelected.set(entreprise.id, true);
			this.updateAvailableEnteprises(travauxPdpEntity);
			travauxPdpEntity.selectedSousTraitants.push({ entreprise: entreprise });
			this.addEntrepriseExterieureOuSousTraitante(entreprise, travauxPdpEntity);
			setTimeout(() => {
				travauxPdpEntity.selectedSousTraitant = null;
			}, 100);
		}
	}

	onSousTraitantDeselected(index: number, element: any) {
		let travauxPdpEntity = this.travaux[element.id - 1];
		let entreprise = travauxPdpEntity.selectedSousTraitants[index].entreprise;
		travauxPdpEntity.sousTraitantsSelected.set(entreprise.id, false);
		this.updateAvailableEnteprises(travauxPdpEntity);
		this.removeEntrepriseOrDesignationFromEntrepriseExtList(entreprise, element);
		travauxPdpEntity.selectedSousTraitants.splice(index, 1);
	}

	private updateAvailableEnteprises(travaux: TravauxPdpEntity) {
		travaux.availableEntreprises = this.entreprises.filter(entreprise => !travaux.entreprisesSelected.get(entreprise.id)
			&& !travaux.sousTraitantsSelected.get(entreprise.id));
	}

	addTravaux = () => {
		let newEntrepriseConcernees: EntrepriseTLR[] = [];
		let newSousTraitantsConcernes: EntrepriseTLR[] = [];
		let entreprisesById: Map<number, EntrepriseTLR> = new Map<number, EntrepriseTLR>();
		let availableEntreprises: EntrepriseTLR[] = [];
		let entreprisesSelected: Map<number, boolean> = new Map<number, boolean>();
		let selectedEntreprises: { entreprise: EntrepriseTLR }[] = [];
		let selectedEntreprise: any;
		let sousTraitantsSelected: Map<number, boolean> = new Map<number, boolean>();
		let selectedSousTraitants: { entreprise: EntrepriseTLR }[] = [];
		let selectedSousTraitant: any;
		this.idTravaux = this.idTravaux + 1;
		this.travaux.push({
			id: this.idTravaux,
			designation: '',
			entreprisesConcernees: newEntrepriseConcernees,
			sousTraitantsConcernes: newSousTraitantsConcernes,
			entreprisesById: entreprisesById,
			availableEntreprises: availableEntreprises,
			entreprisesSelected: entreprisesSelected,
			selectedEntreprises: selectedEntreprises,
			selectedEntreprise: selectedEntreprise,
			sousTraitantsSelected: sousTraitantsSelected,
			selectedSousTraitants: selectedSousTraitants,
			selectedSousTraitant: selectedSousTraitant,
			coactivite: 'Possible',
			updatable: true
		});
		this.designationInitialValueSubject.push(new Subject<string | null>())
		setTimeout(
			() => this.designationInitialValueSubject[this.idTravaux - 1].next(''),
			300
		);
		this.initEntreprisesAndSousTraitantsLists(this.travaux[this.travaux.length - 1], this.entreprises);
	}

	removeLotTravaux(id: number) {
		// suppression entreprises extérieures liées à la ligne de travaux à supprimer
		let entreprisesAndSousTraitantsIdsToRemove: number[] = [];
		this.travaux.find(travaux => travaux.id === id)?.selectedEntreprises
			.forEach(value => entreprisesAndSousTraitantsIdsToRemove.push(value.entreprise.id));
		this.travaux.find(travaux => travaux.id === id)?.selectedSousTraitants
			.forEach(value => entreprisesAndSousTraitantsIdsToRemove.push(value.entreprise.id));
		// vérifier si l'entreprise n'existe pas ailleurs
		entreprisesAndSousTraitantsIdsToRemove.forEach(idEntrepriseToRemove => {
			let indexToRemove = this.entreprisesExterieures.findIndex(entrepriseExt => idEntrepriseToRemove === entrepriseExt.idEntrepriseExt);
			if (indexToRemove > -1) {
				if (this.entreprisesExterieures[indexToRemove].natureInterventions.length === 1) {
					// l'entreprise n'est pas présente sur d'autres lignes de travaux donc on peut la supprimer
					this.entreprisesExterieures.splice(indexToRemove, 1);
					delete this.entreprisesExterieuresData[idEntrepriseToRemove];
				} else {
					//l'entreprise est présente sur d'autres lignes de travaux : on doit supprimer seulement la nature de l'intervention pour celle-ci
					let indexIntervention = this.entreprisesExterieures[indexToRemove].natureInterventions.findIndex(value => idEntrepriseToRemove === value.travauxPdpId);
					this.entreprisesExterieures[indexToRemove].natureInterventions.splice(indexIntervention, 1);
				}
			}
		});

		// maj des refs
		this.travaux = this.travaux.filter(travaux => travaux.id !== id);
		this.travaux.filter(travaux => travaux.id >= id).forEach(travaux => travaux.id -= 1);
		this.idTravaux = this.idTravaux - 1;
		this.designationInitialValueSubject.splice(id - 1, 1);
	}

	formatPhoneNumber(event: Event) {
		return (event.target as HTMLInputElement).value.replace(/[\.\-]/g, ' ')
			.replace(/[^ 0-9]/g, '')
			.replace(/ {2}/g, ' ')
			.replace(/^ /, '')
	}

	setFieldValue(event: any, fieldName: string, idEntreprise: number) {
		switch (fieldName) {
			case 'nomEntreprise':
				this.entreprisesExterieuresData[idEntreprise].raisonSociale = event['target']['value'];
				break;
			case 'fonctionRepresentant':
				this.entreprisesExterieuresData[idEntreprise].fonctionRepresentant = event['target']['value'];
				break;
			case 'indicatifRepresentant':
				let indicatifId = Number(event['id']);
				for (let i = 0; i < this.indicatifsTel.length; i++) {
					if (this.indicatifsTel[i].id === indicatifId) {
						this.entreprisesExterieuresData[idEntreprise].indicatifRepresentant = this.indicatifsTel[i];
						break;
					}
				}
				break;
			case 'telephoneRepresentant':
				this.entreprisesExterieuresData[idEntreprise].telephoneRepresentant = event['target']['value'];
				break;
			case 'emailRepresentant':
				this.entreprisesExterieuresData[idEntreprise].emailRepresentant = event['target']['value'];
				break;
			case 'effectifMoyen':
				this.entreprisesExterieuresData[idEntreprise].effectifMoyen = Number(event['target']['value']);
				break;
		}
	}

	selectRepresentant(intervenant: IntervenantTLR | undefined, idEntreprise: number) {
		if (intervenant) {
			let entreprise = this.entreprisesExterieuresData[idEntreprise];
			entreprise.nomRepresentant = intervenant ? this.getIntervenantLabel(intervenant) : '';
			entreprise.fonctionRepresentant = intervenant.cadreEmploi ? intervenant.cadreEmploi : '';

			if (intervenant.indicatifTelephone) {
				let indicatif = this.indicatifsTel.filter($ => $.dialCode === intervenant.indicatifTelephone)[0];
				entreprise.indicatifRepresentant = indicatif;
			} else {
				entreprise.indicatifRepresentant = null;
			}

			entreprise.telephoneRepresentant = intervenant.telephone ? intervenant.telephone : '';
			entreprise.emailRepresentant = intervenant.email ? intervenant.email : '';
		}
	}

	onNomRepresentantChange(value: string | null, entreprise: EntrepriseExterieureEntity) {
		entreprise.nomRepresentant = value ? value : '';
	}

	private addEntrepriseExterieureOuSousTraitante(entreprise: EntrepriseTLR, travauxPdpEntity: TravauxPdpEntity) {
		let index = this.entreprisesExterieures.findIndex(value => entreprise.id === value.idEntrepriseExt);
		if (index === -1) {
			let newEntrepriseExt = new EntrepriseExterieureEntity();
			newEntrepriseExt.idEntrepriseExt = entreprise.id;
			newEntrepriseExt.nomEntreprise = entreprise.nom;
			newEntrepriseExt.raisonSociale = entreprise.nom;
			newEntrepriseExt.natureInterventions = [];
			newEntrepriseExt.nomRepresentant = '';
			newEntrepriseExt.fonctionRepresentant = '';
			for (let i = 0; i < this.indicatifsTel.length; i++) {
				if (this.indicatifsTel[i].id === 1) {
					newEntrepriseExt.indicatifRepresentant = this.indicatifsTel[i];
					break;
				}
			}
			newEntrepriseExt.telephoneRepresentant = '';
			newEntrepriseExt.emailRepresentant = '';
			newEntrepriseExt.effectifMoyen = 0;
			let newNatureIntervention = new NatureInterventionEntity();
			newNatureIntervention.travauxPdpId = travauxPdpEntity.id;
			newNatureIntervention.intervention = travauxPdpEntity.designation === undefined ? '' : travauxPdpEntity.designation;
			newEntrepriseExt.natureInterventions.push(newNatureIntervention);
			this.entreprisesExterieures.push(newEntrepriseExt);
			this.entreprisesExterieuresData[entreprise.id] = newEntrepriseExt;
		} else {
			let newNatureIntervention = new NatureInterventionEntity();
			newNatureIntervention.travauxPdpId = travauxPdpEntity.id;
			newNatureIntervention.intervention = travauxPdpEntity.designation;
			this.entreprisesExterieures[index].natureInterventions.push(newNatureIntervention);
		}
	}

	private removeEntrepriseOrDesignationFromEntrepriseExtList(entreprise: EntrepriseTLR, element: any) {
		let numberOfOccurencesInSelectedEntreprises = 0;
		let numberOfOccurencesInSelectedSousTraitants = 0;
		this.travaux.forEach(travaux => {
			if (travaux.selectedEntreprises.findIndex(value => entreprise.id === value.entreprise.id) !== -1) {
				numberOfOccurencesInSelectedEntreprises++;
			}
			if (travaux.selectedSousTraitants.findIndex(value => entreprise.id === value.entreprise.id) !== -1) {
				numberOfOccurencesInSelectedSousTraitants++;
			}
		})
		let total = numberOfOccurencesInSelectedEntreprises + numberOfOccurencesInSelectedSousTraitants;
		if (total > 0) {
			if (total === 1) {
				this.entreprisesExterieures = this.entreprisesExterieures.filter(value => entreprise.id !== value.idEntrepriseExt);
				delete this.entreprisesExterieuresData[entreprise.id];
			} else {
				let indexEntrepriseExtWithDesignationToRemove = this.entreprisesExterieures.findIndex(value => entreprise.id === value.idEntrepriseExt);
				let natureInterventionsWithDesignationToRemove = this.entreprisesExterieures[indexEntrepriseExtWithDesignationToRemove].natureInterventions;
				if (natureInterventionsWithDesignationToRemove !== undefined && natureInterventionsWithDesignationToRemove.length > 0) {
					this.entreprisesExterieures[indexEntrepriseExtWithDesignationToRemove].natureInterventions =
						this.entreprisesExterieures[indexEntrepriseExtWithDesignationToRemove].natureInterventions
							.filter(natureIntervention => natureIntervention.travauxPdpId !== element.id);
				}
			}
		}
	}

	onDesignationChange($event: any, element: TravauxPdpEntity) {
		let inputValue: string = '';
		//events are different for onBlur and onSelectItem
		if ($event) {
			inputValue = ($event.target !== undefined && $event.target.value !== undefined) ? $event.target.value : $event;
			if (this.entreprisesExterieures.length > 0) {
				let entrepriseExtAndSousTraitantIdsWithDesignationToUpdate: number[] = [];
				element.selectedEntreprises.forEach(value => entrepriseExtAndSousTraitantIdsWithDesignationToUpdate.push(value.entreprise.id));
				element.selectedSousTraitants.forEach(value => entrepriseExtAndSousTraitantIdsWithDesignationToUpdate.push(value.entreprise.id));
				this.entreprisesExterieures.forEach(entrepriseExt => {
					if (entrepriseExtAndSousTraitantIdsWithDesignationToUpdate.findIndex(id => id === entrepriseExt.idEntrepriseExt) !== -1) {
						entrepriseExt.natureInterventions.filter(value => value.travauxPdpId === element.id).forEach(value => value.intervention = inputValue);
					}
				})
			}
		}
		element.designation = inputValue;
	}

	getListeInterventionsForEntrepriseExterieure = (natureIntervention: NatureInterventionEntity[]) => {
		let result = '';
		natureIntervention.forEach(value => {
			if (result.length > 0) {
				result = result + ', ';
			}
			result = result + value.intervention;
		})
		return result;
	}

	getTitle() {
		let title = 'Création';
		if (this.planPreventionModel) {
			switch (this.planPreventionModel.mode) {
				case 'update':
					title = 'Modification';
					break;
				case 'update':
					title = 'Duplication';
					break;
			}
		}
		return title;
	}

	/**                                                                          **
	 ******************************* MODEL CHANGE *********************************
	 **                                                                          **/

	onInfoGeneralesModelChange = (planPrevention: PlanPreventionEntity) => {
		this.planPreventionModel = planPrevention;
	}

	onEnergieChange = (energie: string | null) => {
		this.energieSubject.next(energie);
	}

	onAntenneChange = (newAntenneId: number) => {
		// antenne has changed
		const antenneAstreintes = this.antennes.get(newAntenneId)?.telephoneAstreintes;
		this.numeroAstreintesCommand.next(antenneAstreintes);
	}

	onCommunicationMutuelleInfoModelChange = (communicationMutuelleInfo: CommunicationMutuelleInfoEntity | undefined) => {
		if (communicationMutuelleInfo !== undefined) {
			if (!this.planPreventionModel.communicationMutuelleInfo) {
				this.planPreventionModel.communicationMutuelleInfo = [];
			}
			if (communicationMutuelleInfo.selected) {
				this.planPreventionModel.communicationMutuelleInfo.push(communicationMutuelleInfo);
			} else {
				this.planPreventionModel.communicationMutuelleInfo = this.planPreventionModel.communicationMutuelleInfo.filter($ => $.id !== communicationMutuelleInfo.id);
			}
		}
	}

	onAnalyseRiskModelChange(analyseRiskModel: TraductionPdp[] | undefined) {
		if (analyseRiskModel != undefined) {
			this.riskActivities = [];
			this.risks = [];
			this.riskMesures = [];
			analyseRiskModel.forEach(trad => {
				if (!trad.traductionKey.trim().startsWith('AUTR')) {
					let selectedActivities = trad.activites.filter(activite => activite.selected);
					selectedActivities.forEach(activite => {
						activite.parent = new TraductionPdp();
						activite.parent.id = trad.id;
						activite.parent.traductionKey = trad.traductionKey;
					});
					this.riskActivities.push.apply(
						this.riskActivities,
						selectedActivities
					);

					let selectedRiskOrImpacts = trad.riskOrImpacts.filter(riskOrImpact => riskOrImpact.selected);
					selectedRiskOrImpacts.forEach(riskOrImpact => {
						riskOrImpact.parent = new TraductionPdp();
						riskOrImpact.parent.id = trad.id;
						riskOrImpact.parent.traductionKey = trad.traductionKey;
					});
					this.risks.push.apply(
						this.risks,
						selectedRiskOrImpacts
					);

					let selectedMesures = trad.mesures.filter(mesure => mesure.selected);
					selectedMesures.forEach(mesure => {
						mesure.parent = new TraductionPdp();
						mesure.parent.id = trad.id;
						mesure.parent.traductionKey = trad.traductionKey;
					});
					this.riskMesures.push.apply(
						this.riskMesures,
						selectedMesures
					);
				} else {
					let selectedActivities = trad.activites;
					selectedActivities.forEach(activite => {
						activite.parent = new TraductionPdp();
						activite.parent.id = trad.id;
						activite.parent.traductionKey = trad.traductionKey;
					});
					this.riskActivities.push.apply(
						this.riskActivities,
						selectedActivities
					);

					let selectedRiskOrImpacts = trad.riskOrImpacts;
					selectedRiskOrImpacts.forEach(riskOrImpact => {
						riskOrImpact.parent = new TraductionPdp();
						riskOrImpact.parent.id = trad.id;
						riskOrImpact.parent.traductionKey = trad.traductionKey;
					});
					this.risks.push.apply(
						this.risks,
						selectedRiskOrImpacts
					);

					let selectedMesures = trad.mesures;
					selectedMesures.forEach(mesure => {
						mesure.parent = new TraductionPdp();
						mesure.parent.id = trad.id;
						mesure.parent.traductionKey = trad.traductionKey;
					});
					this.riskMesures.push.apply(
						this.riskMesures,
						selectedMesures
					);
				}
				this.riskMesures.forEach(selectedMesure => {
					selectedMesure.responsibility = '';
					if (selectedMesure.chargeEntrepriseUtilisatrice && selectedMesure.chargeEntrepriseExterne) {
						selectedMesure.responsibility = 'BOTH';
					} else if (selectedMesure.chargeEntrepriseUtilisatrice) {
						selectedMesure.responsibility = 'EU';
					} else if (selectedMesure.chargeEntrepriseExterne) {
						selectedMesure.responsibility = 'EE';
					}
				});
			});
		}
	}

	onAnalyseImpactModelChange(analyseImpactModel: TraductionPdp[] | undefined) {
		if (analyseImpactModel != undefined) {
			this.impactActivities = [];
			this.impacts = [];
			this.impactMesures = [];
			analyseImpactModel.forEach(trad => {
				if (!trad.traductionKey.trim().startsWith('AUTR')) {
					let selectedActivities = trad.activites.filter(activite => activite.selected);
					selectedActivities.forEach(activite => {
						activite.parent = new TraductionPdp();
						activite.parent.id = trad.id;
						activite.parent.traductionKey = trad.traductionKey;
					});
					this.impactActivities.push.apply(
						this.impactActivities,
						selectedActivities
					);

					let selectedRiskOrImpacts = trad.riskOrImpacts.filter(riskOrImpact => riskOrImpact.selected);
					selectedRiskOrImpacts.forEach(riskOrImpact => {
						riskOrImpact.parent = new TraductionPdp();
						riskOrImpact.parent.id = trad.id;
						riskOrImpact.parent.traductionKey = trad.traductionKey;
					});
					this.impacts.push.apply(
						this.impacts,
						selectedRiskOrImpacts
					);

					let selectedMesures = trad.mesures.filter(mesure => mesure.selected);
					selectedMesures.forEach(mesure => {
						mesure.parent = new TraductionPdp();
						mesure.parent.id = trad.id;
						mesure.parent.traductionKey = trad.traductionKey;
					});
					this.impactMesures.push.apply(
						this.impactMesures,
						selectedMesures
					);
				} else {
					let selectedActivities = trad.activites;
					selectedActivities.forEach(activite => {
						activite.parent = new TraductionPdp();
						activite.parent.id = trad.id;
						activite.parent.traductionKey = trad.traductionKey;
					});
					this.impactActivities.push.apply(
						this.impactActivities,
						selectedActivities
					);

					let selectedRiskOrImpacts = trad.riskOrImpacts;
					selectedRiskOrImpacts.forEach(riskOrImpact => {
						riskOrImpact.parent = new TraductionPdp();
						riskOrImpact.parent.id = trad.id;
						riskOrImpact.parent.traductionKey = trad.traductionKey;
					});
					this.impacts.push.apply(
						this.impacts,
						selectedRiskOrImpacts
					);

					let selectedMesures = trad.mesures;
					selectedMesures.forEach(mesure => {
						mesure.parent = new TraductionPdp();
						mesure.parent.id = trad.id;
						mesure.parent.traductionKey = trad.traductionKey;
					});
					this.impactMesures.push.apply(
						this.impactMesures,
						selectedMesures
					);
				}
				this.impactMesures.forEach(selectedMesure => {
					selectedMesure.responsibility = '';
					if (selectedMesure.chargeEntrepriseUtilisatrice && selectedMesure.chargeEntrepriseExterne) {
						selectedMesure.responsibility = 'BOTH';
					} else if (selectedMesure.chargeEntrepriseUtilisatrice) {
						selectedMesure.responsibility = 'EU';
					} else if (selectedMesure.chargeEntrepriseExterne) {
						selectedMesure.responsibility = 'EE';
					}
				});
			});
		}
	}

	/**                                                                          **
	 ******************************* SERVICES *************************************
	 **                                                                          **/
	onCompletingDefinitionOperation(stepper: MatStepper) {

		this.finalisationTypePdpCommands.next(this.planPreventionModel.typePdp);

		if (this.planPreventionModel.id != null && this.planPreventionModel.id != -1) {
			// Cas ou on est en mode modification

			this.planPreventionService.update(this.planPreventionModel, 'DEFINITION', false).pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("Erreur lors de la création d'un plan de prévention (Erreur " + response.status + ")");
						}
						throw new Error();
					})
			).subscribe(
				(planPreventionStep1: PlanPreventionEntity) => {
					this.planPreventionModel.id = planPreventionStep1.id;
					this.planPreventionModel.versionTechnique = planPreventionStep1.versionTechnique;
					this.finalisationIdPdpCommands.next(this.planPreventionModel.id);
					this.finalisationVersionPdpCommands.next(this.planPreventionModel.versionTechnique);
				}
			);

			if (this.planPreventionModel.parcIds && this.planPreventionModel.antenneId) {
				this.loadEntreprises();

				// Charger les donnees du referent
				this.intervenantService.getIntervenantById(this.planPreventionModel.referentParcId).subscribe((chargesAcces: IntervenantEntity) => {
					this.referentParc = chargesAcces;
					this.idEntrepriseReferent = this.referentParc.idEntreprise;
					this.setEntrepriseReferentOnParcChange();
				});
			}
		} else {
			// Cas ou on est en mode creation

			this.planPreventionService.create(this.planPreventionModel).pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("Erreur lors de la création d'un plan de prévention (Erreur " + response.status + ")");
						}
						throw new Error();
					})
			).subscribe(
				(planPreventionStep1: PlanPreventionEntity) => {
					this.planPreventionModel.id = planPreventionStep1.id;
					this.planPreventionModel.versionTechnique = planPreventionStep1.versionTechnique;
					this.finalisationIdPdpCommands.next(this.planPreventionModel.id);
					this.finalisationVersionPdpCommands.next(this.planPreventionModel.versionTechnique);
					this.pdpToCopyRisks.next(this.pdpIdForDuplication);
					this.pdpToCopyImpacts.next(this.pdpIdForDuplication);
				}
			);

			this.raisonSociale = applicationConstants.raisonSocialeEngieGreen;
			this.adresseEU = applicationConstants.adresseEngieGreen;
			this.telFax = applicationConstants.telFaxEngieGreen;

			if (this.planPreventionModel.parcIds && this.planPreventionModel.antenneId) {
				this.loadEntreprises();

				if (this.planPreventionModel.referentParcId) {
					// Charger les donnees du referent
					this.intervenantService.getIntervenantById(this.planPreventionModel.referentParcId).subscribe((chargesAcces: IntervenantEntity) => {
						this.referentParc = chargesAcces;
						this.nomPrenomReferent = [this.referentParc.nom, this.referentParc.prenom].join(' ');
						this.fonctionReferent = this.referentParc.cadreEmploi;
						this.telephoneReferent = this.referentParc.telephone;
						this.emailReferent = this.referentParc.email;
						this.idEntrepriseReferent = this.referentParc.idEntreprise;
						this.setEntrepriseReferentOnParcChange();
					});
				}
			}
		}

		this.loadLibellesTypeMaintenances(this.planPreventionModel.parcIds, this.planPreventionModel.classeOuvrageIds);

		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	private loadEntreprises() {
		this.entrepriseService.getActiveEntreprisesTLRList().subscribe(
			(entreprises: EntrepriseTLR[]) => {
				// entregister le contexte
				this.entreprises = entreprises.filter( $ => $.documentApplicable === 'PlanPrevention' || $.documentApplicable === 'Both');
				// si on est en mode update : pour les travaux existant on initialise les entreprises
				this.travaux.forEach(tr => {
					tr.entreprisesById = new Map<number, EntrepriseTLR>();
					for (let entreprise of entreprises) {
						tr.entreprisesById.set(entreprise.id, entreprise);
					}
					tr.availableEntreprises = [...entreprises];
					tr.entreprisesSelected = new Map<number, boolean>();
					tr.sousTraitantsSelected = new Map<number, boolean>();
					let selectedEntrepriseIds = tr.selectedEntreprises.map(e => e.entreprise.id);
					let selectedSsTraitantIds = tr.selectedSousTraitants.map(e => e.entreprise.id);
					for (let entreprise of entreprises) {
						if (selectedEntrepriseIds.indexOf(entreprise.id) > -1) {
							tr.entreprisesSelected.set(entreprise.id, true);
						} else {
							tr.entreprisesSelected.set(entreprise.id, false);
						}
						if (selectedSsTraitantIds.indexOf(entreprise.id) > -1) {
							tr.sousTraitantsSelected.set(entreprise.id, true);
						} else {
							tr.sousTraitantsSelected.set(entreprise.id, false);
						}
					}
					this.updateAvailableEnteprises(tr);
				});
			}
		)
	}

	private loadLibellesTypeMaintenances(parcIds: number[], classeOuvrageIds: number[]) {
		if (parcIds.length && classeOuvrageIds.length) {
			this.typeMaintenanceService.getLibellesTypeMaintenancesByParcAndClasse(parcIds, classeOuvrageIds)
				.subscribe((libellesTypeMaintenance: string[]) => {
					this.typeMaintenanceSuggestion = libellesTypeMaintenance;
				}
				);
		}
	}

	private setEntrepriseReferentOnParcChange() {
		if (this.idEntrepriseReferent != undefined) {
			this.entrepriseService.getActiveEntrepriseTLRById(this.idEntrepriseReferent).subscribe((entreprise: EntrepriseTLR) => {
				entreprise.raisonSociale = entreprise.nom;
				this.finalisationEntrepriseUtilisatriceCommands.next(entreprise);
			});
		}
	}

	private mapPlanPreventionDtoStepTwo(): PlanPreventionEntity {
		const copyOfModel: PlanPreventionEntity = { ...this.planPreventionModel };
		/* TRAVAUX */
		copyOfModel.travaux = [];
		this.travaux.forEach(travaux => {
			let t: TravauxPdpEntity = new TravauxPdpEntity();
			t.entreprisesConcernees = [];
			t.sousTraitantsConcernes = [];
			travaux.selectedEntreprises.forEach(value => t.entreprisesConcernees.push(value.entreprise));
			travaux.selectedSousTraitants.forEach(value => t.sousTraitantsConcernes.push(value.entreprise));
			t.coactivite = travaux.coactivite === 'Possible' ? Coactivite.POSSIBLE : Coactivite.NON_POSSIBLE;
			t.designation = travaux.designation;
			t.id = travaux.id;
			copyOfModel.travaux.push(t);
		})

		// Entreprise utilisatrice
		copyOfModel.raisonSociale = this.raisonSociale;
		copyOfModel.adresseEU = this.adresseEU;
		copyOfModel.telFax = this.telFax;
		copyOfModel.nomPrenomReferent = this.nomPrenomReferent;
		copyOfModel.emailReferent = this.emailReferent;
		copyOfModel.fonctionReferent = this.fonctionReferent;
		copyOfModel.telephoneReferent = this.telephoneReferent;
		copyOfModel.emailGenerique = this.emailGenerique;
		copyOfModel.astreinte = this.telephoneAstreinte;

		/* ENTREPRISES EXTERIEURES ET SOUS-TRAITANTS */
		copyOfModel.entreprisesExterieures = this.entreprisesExterieures;
		copyOfModel.entreprisesExterieures.forEach(ee => {
			let entreprise = this.entreprisesExterieuresData[ee.idEntrepriseExt];
			ee.nomEntreprise = entreprise.nomEntreprise;
			ee.raisonSociale = entreprise.raisonSociale;

			let nomRepresentant = entreprise.nomRepresentant;
			ee.nomRepresentant =
				nomRepresentant ?
					nomRepresentant.split('|')[0].trim() :
					''
				;
			ee.fonctionRepresentant = entreprise.fonctionRepresentant;
			ee.emailRepresentant = entreprise.emailRepresentant;
			ee.indicatifIdRepresentant = entreprise.indicatifRepresentant ? entreprise.indicatifRepresentant.id : 1;
			ee.telephoneRepresentant = entreprise.telephoneRepresentant;
			ee.effectifMoyen = entreprise.effectifMoyen;
		});
		return copyOfModel;
	}

	prevalidateStepOne() {
		if (this.planPreventionModel.parcIds && this.planPreventionModel.antenneId) {
			this.loadEntreprises();
			this.loadLibellesTypeMaintenances(this.planPreventionModel.parcIds, this.planPreventionModel.classeOuvrageIds);
			if (this.planPreventionModel.referentParcId) {
				// Charger les donnees du referent
				this.intervenantService.getIntervenantById(this.planPreventionModel.referentParcId).subscribe((chargesAcces: IntervenantEntity) => {
					this.referentParc = chargesAcces;
					this.idEntrepriseReferent = this.referentParc.idEntreprise;
					this.setEntrepriseReferentOnParcChange();
					if (this.planPreventionModel.lastCompletedStep >= 2) {
						this.prevalidateStepTwo();
					}
				});
			}
		}
	}

	prevalidateStepTwo() {
		this.finalisationIdPdpCommands.next(this.planPreventionModel.id);
		this.finalisationVersionPdpCommands.next(this.planPreventionModel.versionTechnique);
		this.finalisationTypePdpCommands.next(this.planPreventionModel.typePdp);
		// conversion entreprise en TLR
		this.entrepriseService.getActiveEntreprisesTLRMapById().subscribe(
			(referenceEntreprises: Map<number, EntrepriseTLR>) => {
				let entreprisesDuPdp: EntrepriseTLR[] = [];
				this.entreprisesExterieures.forEach($ => {
					let entrepriseTLR = referenceEntreprises.get($.idEntrepriseExt);
					if (entrepriseTLR) {
						entreprisesDuPdp.push(entrepriseTLR);
					}
				});
				this.finalisationEntreprisesPouvantSignerCommands.next(entreprisesDuPdp); // FIXME: ajouter entreprise du representant
			}
		);
	}

	onCompletingTravauxEntreprise(stepper: MatStepper) {
		let copyOfModel = this.mapPlanPreventionDtoStepTwo();
		this.planPreventionService.update(copyOfModel, 'TRAVAUX', false).pipe(
			catchError(
				(response: HttpErrorResponse) => {
					if (response.error && response.error.message) {
						alert(response.error.message);
					} else {
						alert("Step 2 - Travaux - Entreprises : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
					}
					throw new Error();
				}
			)
		).subscribe(
			(_planPreventionStep2: PlanPreventionEntity) => {
				// on a fini avec l'id de duplication on le reset
				this.pdpToCopyRisks.next(-1);
				this.pdpToCopyImpacts.next(-1);
				// on map les entreprises pour corriger bug 61797
				let entreprisesDuPdp: EntrepriseTLR[] = [];
				this.entreprisesExterieures.forEach(ee => {
					let entreprise = new EntrepriseTLR();
					entreprise.nom = ee.nomEntreprise;
					entreprise.id = ee.idEntrepriseExt;
					entreprise.raisonSociale = ee.raisonSociale;
					entreprisesDuPdp.push(entreprise);
				});
				this.finalisationEntreprisesPouvantSignerCommands.next(entreprisesDuPdp); // FIXME: ajouter entreprise du representant
			}
		);
		console.log("Validation step 2 : Travaux - Entreprises\nPlan de prevention id : " + this.planPreventionModel.id);
		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	onCompletingCommunicationMutuelleInfo(stepper: MatStepper) {
		this.planPreventionService.update(this.planPreventionModel, 'COMMUNICATION_MUTUELLE_INFOS', false)
			.pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("Step 3 - Communication Mutuelle Info : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
						}
						throw new Error();
					}
				)
			)
			.subscribe(
				(_planPreventionStep3: PlanPreventionEntity) => { }
			);
		console.log("Validation Step 3 - Communication Mutuelle Info\nPlan de prevention id : " + this.planPreventionModel.id);
		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	onCompletingConsignesSecu(stepper: MatStepper) {
		console.log('onCompletingConsignesSecu');
		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	onCompletingRiskStep(stepper: MatStepper) {
		console.log('onCompletingRiskStep');
		// faut updater le PDP avec les cases cochées
		this.planPreventionModel.riskActivities = this.mapToTraductionDto(this.riskActivities);
		this.planPreventionModel.risks = this.mapToTraductionDto(this.risks);
		this.planPreventionModel.riskMesures = this.mapToTraductionDto(this.riskMesures);
		this.planPreventionService.update(this.planPreventionModel, 'ANALYSE_RISK', false)
			.pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("Step 5 - Analyse des risques : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
						}
						throw new Error();
					}
				)
			)
			.subscribe(
				(_response: PlanPreventionEntity) => { }
			);
		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	mapToTraductionDto(traductionPdps: TraductionPdp[]): TraductionDto[] {
		return traductionPdps.map($ => {
			let id = $.traductionKey.startsWith('EXTENDED_AUTR') ? -1 : $.id;
			return new TraductionDto(id, $.responsibility, $.autre, $.poidsFemme, $.poidsHomme, $.traductionKey, $.fr, $.type, $.parent);
		});
	}

	onCompletingImpactStep(stepper: MatStepper) {
		console.log('onCompletingImpactStep');
		// faut updater le PDP avec les cases cochées
		this.planPreventionModel.impactActivities = this.mapToTraductionDto(this.impactActivities);
		this.planPreventionModel.impacts = this.mapToTraductionDto(this.impacts);
		this.planPreventionModel.impactMesures = this.mapToTraductionDto(this.impactMesures);
		this.planPreventionService.update(this.planPreventionModel, 'ANALYSE_IMPACT', false)
			.pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("Step 5 - Analyse des impacts : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
						}
						throw new Error();
					}
				)
			)
			.subscribe(
				(_response: PlanPreventionEntity) => { }
			);
		if (stepper && stepper.selected) {
			stepper.selected.completed = true;// move to next step
			stepper.next();
		}
	}

	valideurSignatairesApplicable(): boolean {
		return this.planPreventionModel.versionTechnique >= applicationConstants.versionInWhichValideursCanSignPdps && this.planPreventionModel.typePdp === 0;
	}

	onFinalisationModelChange(stepFinalModel: StepFinalModel) {
		this.planPreventionModel.dateInspectionCommunePrealable = stepFinalModel.dateInspectionCommunePrealable;
		if (this.valideurSignatairesApplicable()) {
			this.planPreventionModel.valideurSignataires = stepFinalModel.valideurSignataires;
			this.planPreventionModel.valideurSignataires.forEach(valideur => {
				if (this.planPreventionModel.mode === 'duplicate') {
					valideur.docusignEnvelopeId = -1;
					valideur.dateSignature = '';
					valideur.docusignRecipientId = '';
					valideur.hasSigned = false;
					valideur.hasSignedEnvelope = false;
					valideur.sentToDocusign = false;
				}
			});
		} else {
			this.planPreventionModel.valideurs = stepFinalModel.valideurs;
		}
		stepFinalModel.nouveauxRisques.forEach(nouveauRisque => {
			nouveauRisque.entreprisesConcernees = [];
			nouveauRisque.selectedEntreprises.forEach(value => {
				nouveauRisque.entreprisesConcernees.push(value.entreprise);
			});
		});
		this.planPreventionModel.nouveauxRisques = stepFinalModel.nouveauxRisques;

		this.planPreventionModel.signataires = stepFinalModel.signataires;
		this.planPreventionModel.signataires.forEach(signataire => {
			if (this.planPreventionModel.mode === 'duplicate') {
				signataire.envelopeId = '';
				signataire.hasSigned = false;
				signataire.hasSignedEnvelope = false;
				signataire.sentToDocusign = false;
			}
		});

		this.planPreventionModel.representants = stepFinalModel.representants;
		this.planPreventionModel.representants.forEach(representant => {
			if (this.planPreventionModel.mode === 'duplicate') {
				representant.docusignEnvelopeId = -1;
				representant.dateSignature = '';
				representant.docusignRecipientId = '';
				representant.hasSigned = false;
				representant.hasSignedEnvelope = false;
				representant.sentToDocusign = false;
			}
		});
	}

	onCompletingFinalisation(_stepper: MatStepper, shouldIncrementVersion: boolean) {
		this.planPreventionService.update(this.planPreventionModel, 'FINALISATION', shouldIncrementVersion)
			.subscribe({
				next: (_response: PlanPreventionEntity) => {
					this.eventBusService.emit(Events.RefreshBatchIndicatorRequested, null);
					if (shouldIncrementVersion) {
						this.generationCommands.next(this.planPreventionModel);
					} else {
						alert('Le plan de prévention ' + this.planPreventionModel.numeroPdp + ' a été sauvegardé');
					}
				},
				error: (response: HttpErrorResponse) => {
					if (response.error && response.error.message) {
						alert(response.error.message);
					} else {
						alert("Step 7 - Finalisation : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
					}
				}
			});
	}

	gotoListPdp(stepper: MatStepper) {
		stepper.selectedIndex = 0; // remet le stepper sur le premier steps pour la prochaine fois qu'on rouvre le stepper
		stepper.reset();
		this.pdpIdForDuplication = -1;
		this.pdpToCopyRisks.next(-1);
		this.pdpToCopyImpacts.next(-1);
		this.pdpToCopyInFinalisation.next(-1);
		this.viewChange.emit('list');
	}

	save(stepper: MatStepper) {
		if (confirm('Sauvegarder l\'état en cours et revenir sur la liste des plans de prévention ?')) {
			console.log('stepper: ', stepper);
			// en fonction du step sauvegarder les données
			switch (stepper.selectedIndex) {
				case 0:
					if (this.planPreventionModel.id != null && this.planPreventionModel.id != -1) {
						this.planPreventionService.update(this.planPreventionModel, 'DEFINITION', false).pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Erreur lors de la sauvegarde d'un plan de prévention (Erreur " + response.status + ")");
									}
									throw new Error();
								})
						).subscribe(
							(_planPreventionStep1: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						);
					} else {
						this.planPreventionService.create(this.planPreventionModel).pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Erreur lors de la création d'un plan de prévention (Erreur " + response.status + ")");
									}
									throw new Error();
								})
						).subscribe(
							(_response: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						);
					}
					break;
				case 1:
					let copyOfModel = this.mapPlanPreventionDtoStepTwo();
					this.planPreventionService.update(copyOfModel, 'TRAVAUX', false)
						.pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Step 2 - Travaux - Entreprises : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
									}
									throw new Error();
								}
							)
						).subscribe(
							(_response: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						)
						;
					break;
				case 2:
					this.planPreventionService.update(this.planPreventionModel, 'COMMUNICATION_MUTUELLE_INFOS', false)
						.pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Step 3 - Communication Mutuelle Info : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
									}
									throw new Error();
								}
							)
						)
						.subscribe(
							(_response: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						)
						;
					break;
				case 3:
					// rien à faire
					break;
				case 4:
					this.planPreventionModel.riskActivities = this.mapToTraductionDto(this.riskActivities);
					this.planPreventionModel.risks = this.mapToTraductionDto(this.risks);
					this.planPreventionModel.riskMesures = this.mapToTraductionDto(this.riskMesures);
					this.planPreventionService.update(this.planPreventionModel, 'ANALYSE_RISK', false)
						.pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Step 5 - Analyse des risques : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
									}
									throw new Error();
								}
							)
						)
						.subscribe(
							(_response: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						)
						;
					break;
				case 5:
					this.planPreventionModel.impactActivities = this.mapToTraductionDto(this.impactActivities);
					this.planPreventionModel.impacts = this.mapToTraductionDto(this.impacts);
					this.planPreventionModel.impactMesures = this.mapToTraductionDto(this.impactMesures);
					this.planPreventionService.update(this.planPreventionModel, 'ANALYSE_IMPACT', false)
						.pipe(
							catchError(
								(response: HttpErrorResponse) => {
									if (response.error && response.error.message) {
										alert(response.error.message);
									} else {
										alert("Step 5 - Analyse des impacts : Erreur lors de la mise à jour du plan de prévention" + this.planPreventionModel.id + " (Erreur " + response.status + ")");
									}
									throw new Error();
								}
							)
						)
						.subscribe(
							(_response: PlanPreventionEntity) => {
								// puis retourner sur la liste des pdps
								this.gotoListPdp(stepper);
							}
						)
						;
					break;
			}
		}
	}

	isDisabled(step: number): boolean {
		let isDisabled: boolean = false;
		if (this.planPreventionModel && this.activeStep === step) {
			switch (step) {
				case 1:
					isDisabled = !this.planPreventionModel.ouvrages || this.planPreventionModel.ouvrages.length === 0 || this.planPreventionModel.numeroPdp == null
						|| this.planPreventionModel.numeroPdp.length === 0 || this.planPreventionModel.parcIds == null
						|| this.planPreventionModel.debutValidite == null || this.planPreventionModel.debutValidite.length === 0
						|| this.planPreventionModel.finValidite == null || this.planPreventionModel.finValidite.length === 0;
					if (!isDisabled && this.planPreventionModel.typePdp === 1) {
						isDisabled = this.planPreventionModel.duree == null || this.planPreventionModel.duree > 364 || this.planPreventionModel.duree < 0;
					}
					break;
				case 2:
					// au moins un travaux
					if (this.travaux && this.entreprisesExterieures) {
						let ees = Object.values(this.entreprisesExterieuresData);
						isDisabled = this.travaux.length === 0;
						// pour chaque travaux : designation obligatoire, entreprise obligatoire, et reponse sur la coactivité obligatoire
						if (this.travaux.length > 0) {
							let existTravauxSansDesignation = this.travaux.some($ => $.designation.trim().length === 0);
							let existTravauxSansEntreprise = this.travaux.some($ => $.selectedEntreprises.length === 0);
							let existTravauxSansRenseignementCoactivite = this.travaux.some($ => $.coactivite.length === 0);
							let existEeSansNomRepresentant = ees.some($ => $.nomRepresentant == null || $.nomRepresentant.length === 0);
							isDisabled = existTravauxSansDesignation || existTravauxSansEntreprise || existTravauxSansRenseignementCoactivite
								|| this.telephoneAstreinte.length === 0 || this.telephoneAstreinte.every($ => $.trim().length === 0) || existEeSansNomRepresentant;
						}
					}
					break;
				case 3:
				case 4:
					return false;// rien à valider sur les steps 3 et 4
				case 5:
					// analyse de risk
					this.highlightedSections = [];
					this.aucunRiskChoisi = false;
					// section autre incomplet 
					if (this.isSectionAutreRiskIncomplet()) {
						this.highlightedSections.push(this.riskActivities.filter(activity => activity.traductionKey.startsWith('AUTR'))[0].parent.id);
					}
					// sections avec mesures sans EU EE
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.riskMesures.filter(mesure => !mesure.responsibility).map($ => $.parent.id)
					);
					// sections avec activites sans risques
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.sectionsWithActivitesSansRisques()
					);
					// sections avec risques sans mesures
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.sectionsWithRisquesSansMesures()
					);
					this.aucunRiskChoisi = this.riskActivities.length === 0;
					isDisabled = this.highlightedSections.length > 0 || this.aucunRiskChoisi;
					break;
				case 6:
					// analyse d'impacts
					this.highlightedSections = [];
					// section autre incomplet 
					if (this.isSectionAutreImpactsIncomplet()) {
						this.highlightedSections.push(this.impactActivities.filter(activity => activity.traductionKey.startsWith('AUTR'))[0].parent.id);
					}
					// sections avec mesures sans EU EE
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.impactMesures.filter(mesure => !mesure.responsibility).map($ => $.parent.id)
					);
					// sections avec activites sans impacts
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.sectionsWithActivitesSansImpacts()
					);
					// sections avec impacts sans mesures
					this.highlightedSections.push.apply(
						this.highlightedSections,
						this.sectionsWithImpactsSansMesures()
					);
					isDisabled = this.highlightedSections.length > 0;
					break;
				case 7:
					let blocValideurInvalid = false;
					if ((this.planPreventionModel.valideurs && this.planPreventionModel.valideurs.length > 0) || (this.planPreventionModel.valideurSignataires && this.planPreventionModel.valideurSignataires.length > 0)) {
						if (this.valideurSignatairesApplicable()) {
							// pdp general v3++
							blocValideurInvalid = this.planPreventionModel.valideurSignataires.some(value => value.intervenantId < 0 || value.intervenantEntrepriseId < 0);
							blocValideurInvalid = blocValideurInvalid || this.planPreventionModel.valideurSignataires.some(value => value.emailStyle === 'error');
							blocValideurInvalid = blocValideurInvalid || this.planPreventionModel.representants.some(value => value.emailStyle === 'error');
							blocValideurInvalid = blocValideurInvalid || this.planPreventionModel.signataires.some(value => value.emailStyle === 'error');
						} else {
							// specifique ou general v2--
							blocValideurInvalid = this.planPreventionModel.valideurs.some(value => value.nomPrenomValidateur.length === 0) || this.planPreventionModel.valideurs.some(value => !value.entrepriseValidateur.id);
							blocValideurInvalid = blocValideurInvalid || this.planPreventionModel.signataires.some(value => value.emailStyle === 'error');
						}
					}
					isDisabled = blocValideurInvalid ||
						(this.planPreventionModel.nouveauxRisques && this.planPreventionModel.nouveauxRisques.length > 0 &&
							(this.planPreventionModel.nouveauxRisques.some(value => !value.dateApparitionNouveauRisque || value.dateApparitionNouveauRisque?.length === 0)
								|| this.planPreventionModel.nouveauxRisques.some(value => value.causeApparition.length === 0)
								|| this.planPreventionModel.nouveauxRisques.some(value => value.selectedEntreprises.length === 0))) ||
						!this.planPreventionModel.dateInspectionCommunePrealable;
					break;
			}
			this.nextDisabled = isDisabled;
			if (isDisabled) {
				this.toggleMandatoryFields(isDisabled);
			} else {
				this.toggleMandatoryFields(isDisabled);
			}
		}
		return isDisabled;
	}

	private sectionsWithActivitesSansRisques(): number[] {
		let sections: number[] = [];
		this.riskActivities.filter(a => !a.traductionKey.startsWith('AUTR')).forEach(act => {
			let parentId = act.parent.id;
			if (!this.risks.some(r => !r.traductionKey.startsWith('AUTR') && r.parent.id === parentId)) {
				sections.push(parentId);
			}
		});
		return sections;
	}

	private sectionsWithRisquesSansMesures(): number[] {
		let sections: number[] = [];
		this.risks.filter(risque => !risque.traductionKey.startsWith('AUTR')).forEach(r => {
			let parentId = r.parent.id;
			if (!this.riskMesures.some(mesure => !mesure.traductionKey.startsWith('AUTR') && mesure.parent.id === parentId)) {
				sections.push(parentId);
			}
		});
		return sections;
	}

	private sectionsWithActivitesSansImpacts(): number[] {
		let sections: number[] = [];
		this.impactActivities.filter(a => !a.traductionKey.startsWith('AUTR')).forEach(act => {
			let parentId = act.parent.id;
			if (!this.impacts.some(i => !i.traductionKey.startsWith('AUTR') && i.parent.id === parentId)) {
				sections.push(parentId);
			}
		});
		return sections;
	}

	private sectionsWithImpactsSansMesures(): number[] {
		let sections: number[] = [];
		this.impacts.filter(imp => !imp.traductionKey.startsWith('AUTR')).forEach(i => {
			let parentId = i.parent.id;
			if (!this.impactMesures.some(mesure => !mesure.traductionKey.startsWith('AUTR') && mesure.parent.id === parentId)) {
				sections.push(parentId);
			}
		});
		return sections;
	}

	private isSectionAutreImpactsIncomplet() {
		let isInputAutreImpactsEmpty = this.impactMesures.filter(mesure => mesure.traductionKey.startsWith('AUTR')).some(mesure => !mesure.fr.length)
			|| this.impactActivities.filter(activity => activity.traductionKey.startsWith('AUTR')).some(activity => !activity.fr.length)
			|| this.impacts.filter(riskRsk => riskRsk.traductionKey.startsWith('AUTR')).some(riskRsk => !riskRsk.fr.length);
		return isInputAutreImpactsEmpty;
	}

	private isSectionAutreRiskIncomplet() {
		let isSectionAutreRiskIncomplet: boolean = this.riskMesures.filter(mesure => mesure.traductionKey.startsWith('AUTR')).some(mesure => !mesure.fr.length)
			|| this.riskActivities.filter(activity => activity.traductionKey.startsWith('AUTR')).some(activity => !activity.fr.length)
			|| this.risks.filter(riskRsk => riskRsk.traductionKey.startsWith('AUTR')).some(riskRsk => !riskRsk.fr.length);
		return isSectionAutreRiskIncomplet;
	}

	stepChange(event: StepperSelectionEvent) {
		console.log('passage en step ', event.selectedIndex, ': ', event.selectedStep);
		this.activeStep = event.selectedIndex + 1;
	}

	toggleMandatoryFields(highlight: boolean) {
		this.mandatoryStepOne = highlight;
		this.mandatoryStepTwo = highlight;
		this.mandatoryStepFive = highlight;
		this.mandatoryStepSix = highlight;
		this.mandatoryStepSeven = highlight;
	}

	onPdpGenerationDecision(_event: any) {
		// rien à faire ici
	}

	onNumeroAstreinteSelected(selectedNumeroAstreinte: string[]) {
		console.log('onNumeroAstreinteSelected: ', selectedNumeroAstreinte);
		this.telephoneAstreinte = selectedNumeroAstreinte;
	}

}
